// third-party
import { combineReducers } from 'redux';

// project import
import menu from './menu';
import listView from './listView';

// ==============================|| COMBINE REDUCERS ||============================== //

const reducers = combineReducers({ menu, listView });

export default reducers;
